// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.interactions.dto.HpModifiableUserInteraction

export enum HpModifiableUserInteraction {
  FAVORITE = 'favorite',
  HIDE = 'hide',
  TOUR = 'tour',
  VIEW = 'view',
}

export const HpModifiableUserInteraction_values = [
  HpModifiableUserInteraction.FAVORITE,
  HpModifiableUserInteraction.HIDE,
  HpModifiableUserInteraction.TOUR,
  HpModifiableUserInteraction.VIEW,
] as const;
